var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dynamic-object-form-structure", {
    attrs: {
      "object-uuid": _vm.objectUUID,
      "object-layer": _vm.objectLayer,
      "loading-structure": _vm.loadingStructure,
      "loading-save": _vm.loadingSave,
      "permission-name": _vm.form.permission,
      "object-type-translation-key": _vm.form.name_translation,
      tabs: _vm.visibleTabs,
      "active-tab": _vm.activeTab,
      "action-type": _vm.actionType,
      "map-element": _vm.$parent.$refs.formsContainer,
      "previous-pos-x": _vm.previousPosX,
      "previous-pos-y": _vm.previousPosY,
      "data-was-changed": _vm.dataWasChanged,
      "save-is-disabled": _vm.saveIsDisabled,
      "fields-still-need-filled": _vm.required.stillNeedFilled,
      assets: _vm.objectData.associated_network_elements,
      "internal-reference": _vm.internalReference,
      "object-data": _vm.objectData
    },
    on: {
      updateActiveTab: function($event) {
        _vm.activeTab = $event
      },
      changeViewMode: _vm.changeViewModeOfObject,
      clearData: _vm.clearData,
      save: _vm.saveObject,
      close: _vm.closeForm
    },
    scopedSlots: _vm._u([
      {
        key: "formFields",
        fn: function() {
          return [
            _c("template-tab", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.visibleTabs[_vm.activeTab].code ===
                    "asset_reservation_template_selection",
                  expression:
                    "\n        visibleTabs[activeTab].code === 'asset_reservation_template_selection'\n      "
                }
              ],
              attrs: {
                "action-type": _vm.actionType,
                disabled:
                  _vm.actionType !== "create" &&
                  _vm.actionType !== "createAssetReservation",
                "template-id": _vm.objectData.ar_template_id
              },
              on: {
                "update-id": function($event) {
                  return _vm.setValueInObject("ar_template_id", $event)
                },
                "update-template": function($event) {
                  _vm.template = $event
                },
                "update-only-used-elements": function($event) {
                  _vm.onlyUsedElements = $event
                }
              }
            }),
            _vm._v(" "),
            _vm.visibleTabs[_vm.activeTab].code === "asset_reservation_assets"
              ? _c("assets-tab", {
                  staticStyle: { maxHeight: "65vh" },
                  attrs: {
                    disabled: _vm.readOnly,
                    "action-type": _vm.actionType,
                    wkt: _vm.wkt,
                    template: _vm.template,
                    assets: _vm.associated_assets,
                    "only-used-elements": _vm.onlyUsedElements
                  },
                  on: {
                    "update-assets": function($event) {
                      return _vm.updateAssets($event)
                    },
                    "add-asset-to-delete": _vm.addAssetToDelete
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleTabs[_vm.activeTab].code ===
            "asset_reservation_network_elements"
              ? _c("network-elements-tab", {
                  attrs: {
                    disabled: _vm.readOnly,
                    "action-type": _vm.actionType,
                    wkt: _vm.wkt,
                    template: _vm.template,
                    "network-elements":
                      _vm.objectData.associated_network_elements
                  },
                  on: {
                    "dissociate-asset-reservation-object": function($event) {
                      return _vm.dissociateAssetReservationObject(
                        $event,
                        "associated_network_elements"
                      )
                    },
                    "update-network-elements": function($event) {
                      _vm.objectData.associated_network_elements = $event
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleTabs[_vm.activeTab].type === "form",
                    expression: "visibleTabs[activeTab].type === 'form'"
                  }
                ],
                staticClass: "form tab-content"
              },
              _vm._l(_vm.visibleTabs[_vm.activeTab].fields, function(field) {
                return _c("input-field", {
                  key:
                    _vm.visibleTabs[_vm.activeTab].code +
                    field.label +
                    field.order,
                  ref: "formInputField",
                  refInFor: true,
                  attrs: {
                    value: _vm.getValueInObject(
                      field.var_name,
                      field.input_type
                    ),
                    label: field.label_client
                      ? field.label_client
                      : field.label,
                    "variable-name": field.var_name,
                    inputType: field.input_type,
                    size: field.size,
                    required:
                      field.var_name === "ar_dropped_by"
                        ? _vm.objectData.ar_dropped_date !== null
                        : field.required,
                    "required-filled": _vm.required.filled,
                    selectOptions: field.select_list_name,
                    radioOptions: field.radio_options,
                    fieldDisabled:
                      field.var_name === "ar_external_id"
                        ? _vm.template.art_type === "TPA"
                        : field.disable,
                    tabDisabled:
                      !_vm.userCanEditTabContent(
                        _vm.visibleTabs[_vm.activeTab]
                      ) || _vm.actionType === "addAssetsToReservation",
                    formDisabled: _vm.readOnly,
                    hide: field.hide,
                    checkboxOptions: field.checkbox_options,
                    "object-data": _vm.objectData,
                    restrictSpecialCharacters: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.setValueInObject(
                        field.var_name,
                        $event,
                        field.input_type
                      )
                    },
                    updateCheckboxValue: function($event) {
                      return _vm.updateCheckboxValue($event)
                    },
                    removePhoto: function($event) {
                      return _vm.addToPhotosToRemove($event)
                    }
                  }
                })
              }),
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1526d3e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1526d3e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/ObjectForms/AssetReservationForm.vue
// module id = null
// module chunks = 